module.exports = __webpack_public_path__ + "3b54f6ea78c8bf335f4d50982428e993.png";